import React from 'react'

const IconSwitch = ({size, className, onClick}) => {
    return (
        <svg onClick={onClick} className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.6 3L14.2 7.53333H17.5V15.4667C17.5 16.7133 16.51 17.7333 15.3 17.7333C14.09 17.7333 13.1 16.7133 13.1 15.4667V7.53333C13.1 5.02867 11.131 3 8.7 3C6.269 3 4.3 5.02867 4.3 7.53333V15.4667H1L5.4 20L9.8 15.4667H6.5V7.53333C6.5 6.28667 7.49 5.26667 8.7 5.26667C9.91 5.26667 10.9 6.28667 10.9 7.53333V15.4667C10.9 17.9713 12.869 20 15.3 20C17.731 20 19.7 17.9713 19.7 15.4667V7.53333H23L18.6 3Z" fill="white" />
        </svg>

    )
}

export default IconSwitch
